import {adminUserConstants} from "../../constants/constants";

const initState = {
    table: {
        filter: {},
    } 
}
const adminUsersReducer = (state = initState, action) => {
    switch (action.type) {
        case adminUserConstants.LOAD_ADMIN_USER_TABLE: {
            return {
                ...state,
                table: action.data
            }
        }
        default:
            return state;
    }
}

export default adminUsersReducer;